import React from 'react'

const BuildingIcon = () => (
	<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M17.6836 19V3C17.6836 1.89543 16.7882 1 15.6836 1H5.68359C4.57902 1 3.68359 1.89543 3.68359 3V19M17.6836 19L19.6836 19M17.6836 19H12.6836M3.68359 19L1.68359 19M3.68359 19H8.68359M7.68359 4.99998H8.68359M7.68359 8.99998H8.68359M12.6836 4.99998H13.6836M12.6836 8.99998H13.6836M8.68359 19V14C8.68359 13.4477 9.13131 13 9.68359 13H11.6836C12.2359 13 12.6836 13.4477 12.6836 14V19M8.68359 19H12.6836"
			className="stroke-current"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
)

export default BuildingIcon
